/* ANG Lexend theme. One IIFE. Every feature is delegated or scoped to its own section root,
   so a second instance of any section never drives the first one's DOM. */
(function () {
  'use strict';
  var R = window.lxRoutes || {};
  var S = window.lxStrings || {};
  var MF = window.lxMoneyFormat || 'AED {{amount}}';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    return moneyFull(cents).replace(/([.,])00(?!\d)/, '');
  }
  function moneyFull(cents) {
    var n = (cents / 100);
    var fmt = MF.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = fmt ? fmt[1] : 'amount';
    var v;
    if (key === 'amount_no_decimals') v = Math.round(n).toLocaleString('en-US');
    else if (key === 'amount_with_comma_separator') v = n.toFixed(2).replace('.', ',');
    else v = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MF.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function focusables(root) { return $$('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])', root).filter(function (el) { return el.offsetParent !== null; }); }
  function trap(root, e) {
    if (e.key !== 'Tab') return;
    var f = focusables(root); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function fail(err) { window.alert((err && (err.description || err.message)) || S.error || 'Something went wrong. Please try again.'); }

  /* ---------------- cart drawer ---------------- */
  var cart = {
    root: function () { return document.getElementById('lx-cart'); },
    lastFocus: null,
    timer: null,
    open: function () {
      var r = cart.root();
      if (!r) { window.location.href = R.cart_url || '/cart'; return; }
      if (cart.timer) { clearTimeout(cart.timer); cart.timer = null; }
      if (!r.contains(document.activeElement)) cart.lastFocus = document.activeElement;
      $$('[data-lx-cart-layer]', r).forEach(function (el) { el.hidden = false; });
      requestAnimationFrame(function () { r.classList.add('is-open'); });
      document.documentElement.classList.add('lx-lock');
      setTimeout(function () { var x = $('[data-lx-cart-close].lx-ic', r); if (x) x.focus(); }, 80);
    },
    close: function () {
      var r = cart.root(); if (!r || !r.classList.contains('is-open')) return;
      r.classList.remove('is-open');
      document.documentElement.classList.remove('lx-lock');
      if (cart.timer) clearTimeout(cart.timer);
      cart.timer = setTimeout(function () { $$('[data-lx-cart-layer]', r).forEach(function (el) { el.hidden = true; }); cart.timer = null; }, 280);
      if (cart.lastFocus && cart.lastFocus.focus) { try { cart.lastFocus.focus(); } catch (e) {} }
      cart.lastFocus = null;
    },
    refresh: function (openAfter) {
      /* a failed REFRESH after a good add must never read as a failed add: fall back to the badge */
      return fetch((R.root || '/') + '?sections=lx-cart-drawer')
        .then(function (r) { if (!r.ok) throw new Error('render ' + r.status); return r.json(); })
        .then(function (data) {
          var html = data && data['lx-cart-drawer'];
          var r = cart.root();
          if (!html || !r) return;
          var tmp = document.createElement('div'); tmp.innerHTML = html;
          var fresh = tmp.querySelector('#lx-cart');
          if (!fresh) return;
          var wasOpen = r.classList.contains('is-open');
          r.innerHTML = fresh.innerHTML;
          if (openAfter || wasOpen) {
            $$('[data-lx-cart-layer]', r).forEach(function (el) { el.hidden = false; });
            r.classList.add('is-open');
            document.documentElement.classList.add('lx-lock');
            if (!r.contains(document.activeElement)) { var x = $('[data-lx-cart-close].lx-ic', r); if (x) x.focus(); }
          }
        })
        .catch(function () {})
        .then(function () { cart.badge(); });
    },
    badge: function () {
      return fetch((R.cart_url || '/cart') + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (c) {
        $$('[data-lx-count]').forEach(function (b) { b.textContent = c.item_count; b.hidden = c.item_count === 0; });
        $$('[data-lx-cart-open]').forEach(function (a) { a.setAttribute('aria-label', (S.cartAria || 'Cart, [n] items').replace('[n]', c.item_count)); });
      }).catch(function () {});
    },
    add: function (body) {
      return fetch(R.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; }, function () { throw new Error(S.error); });
          return r.json();
        })
        .then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          return cart.refresh(true);
        });
    },
    /* one queue of intents keyed by line KEY: taps coalesce, nothing is dropped, newest wins */
    pending: {}, inFlight: false, flushTimer: null,
    setQty: function (key, qty) {
      if (!key) return;
      cart.pending[key] = Math.max(0, qty);
      clearTimeout(cart.flushTimer);
      cart.flushTimer = setTimeout(cart.flush, 260);
    },
    flush: function () {
      if (cart.inFlight) { clearTimeout(cart.flushTimer); cart.flushTimer = setTimeout(cart.flush, 160); return; }
      var updates = cart.pending;
      if (!Object.keys(updates).length) return;
      cart.pending = {}; cart.inFlight = true;
      fetch((R.cart_update_url || '/cart/update') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates })
      }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); })
        .catch(function (e) { fail(e); })
        .then(function () {
          cart.inFlight = false;
          if (Object.keys(cart.pending).length) { clearTimeout(cart.flushTimer); return cart.flush(); }
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          return cart.refresh(false);
        });
    }
  };
  window.lxCart = cart;

  document.addEventListener('click', function (e) {
    var t = e.target;
    var op = t.closest('[data-lx-cart-open]');
    if (op && cart.root()) { e.preventDefault(); cart.open(); cart.refresh(true); return; }
    if (t.closest('[data-lx-cart-close]')) { e.preventDefault(); cart.close(); return; }
    var q = t.closest('[data-lx-q]');
    if (q) {
      var line = q.closest('[data-key]'); if (!line) return;
      var span = $('[data-lx-qv]', line);
      var next = Math.max(0, parseInt(span.textContent, 10) + parseInt(q.getAttribute('data-lx-q'), 10));
      span.textContent = next;
      line.classList.toggle('is-going', next === 0);
      cart.setQty(line.getAttribute('data-key'), next);
      return;
    }
    var su = t.closest('[data-lx-stepup]');
    if (su) { e.preventDefault(); su.disabled = true; cart.setQty(su.getAttribute('data-lx-stepup'), parseInt(su.getAttribute('data-q'), 10) || 2); return; }
    var rm = t.closest('[data-lx-rm]');
    if (rm) { e.preventDefault(); var l2 = rm.closest('[data-key]'); l2.classList.add('is-going'); cart.setQty(l2.getAttribute('data-key'), 0); return; }
    var qa = t.closest('[data-lx-add]');
    if (qa) {
      e.preventDefault();
      var lbl = qa.innerHTML;
      qa.classList.add('is-busy'); qa.setAttribute('aria-busy', 'true');
      var fd = new FormData(); fd.append('id', qa.getAttribute('data-lx-add')); fd.append('quantity', qa.getAttribute('data-qty') || 1);
      cart.add(fd).then(function () { qa.classList.remove('is-busy'); qa.removeAttribute('aria-busy'); qa.innerHTML = lbl; })
        .catch(function (err) { qa.classList.remove('is-busy'); qa.removeAttribute('aria-busy'); qa.innerHTML = lbl; fail(err); });
    }
  });
  document.addEventListener('keydown', function (e) {
    var r = cart.root();
    if (r && r.classList.contains('is-open')) { if (e.key === 'Escape') cart.close(); else trap($('.lx-cd', r), e); }
  });

  /* every product form posts through AJAX unless it opts out.
     The tap is handled on click, so the browser never fires a native submit: Shopify counts a cart add
     once for a submit event and again for the AJAX request, which doubled AddToCart in every ad pixel.
     One add per form at a time: a second tap while the first is in flight is ignored. */
  function isAddForm(form) {
    return form && (form.getAttribute('action') || '').match(/\/cart\/add/) && !form.hasAttribute('data-no-ajax');
  }
  function addForm(form) {
    if (form.__lxBusy) return;
    form.__lxBusy = true;
    var btn = $('[type=submit][name=add]', form) || $('[type=submit]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = S.adding || 'Adding...'; }
    var done = function () { form.__lxBusy = false; if (btn) { btn.disabled = false; btn.innerHTML = label; } };
    cart.add(new FormData(form)).then(done).catch(function (err) { done(); fail(err); });
  }
  window.lxAddForm = addForm;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('button[type=submit], input[type=submit]');
    if (!b) return;
    var form = b.form || b.closest('form');
    if (!isAddForm(form)) return;
    e.preventDefault();
    addForm(form);
  });
  document.addEventListener('submit', function (e) {
    if (!isAddForm(e.target)) return;
    e.preventDefault();
    addForm(e.target);
  });

  /* ---------------- announcement ---------------- */
  ready(function () {
    $$('[data-lx-ann]').forEach(function (root) {
      var msgs = $$('.lx-ann__msg', root); if (msgs.length < 2) return;
      var i = 0, iv = null;
      function show(n) { msgs[i].classList.remove('is-on'); i = (n + msgs.length) % msgs.length; msgs[i].classList.add('is-on'); }
      $$('[data-lx-ann-prev]', root).forEach(function (b) { b.addEventListener('click', function () { show(i - 1); restart(); }); });
      $$('[data-lx-ann-next]', root).forEach(function (b) { b.addEventListener('click', function () { show(i + 1); restart(); }); });
      function restart() { if (iv) clearInterval(iv); if (!reduce) iv = setInterval(function () { show(i + 1); }, parseInt(root.getAttribute('data-lx-ann'), 10) * 1000 || 5000); }
      root.addEventListener('mouseenter', function () { if (iv) clearInterval(iv); });
      root.addEventListener('mouseleave', restart);
      restart();
    });
  });

  /* ---------------- header: dropdowns, mobile menu, search ---------------- */
  function closeDrops(except) {
    $$('.lx-nav__item.is-open').forEach(function (li) {
      if (li === except) return;
      li.classList.remove('is-open');
      var b = $('[data-lx-drop]', li); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-drop]');
    if (b) {
      var li = b.closest('.lx-nav__item');
      var open = !li.classList.contains('is-open');
      closeDrops(li);
      li.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!e.target.closest('.lx-nav__item')) closeDrops();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrops(); });

  var mm = { el: null, opener: null };
  function mmOpen(btn) {
    mm.el = document.getElementById('lx-mm'); if (!mm.el) return;
    mm.opener = btn;
    mm.el.hidden = false;
    requestAnimationFrame(function () { mm.el.classList.add('is-open'); });
    document.documentElement.classList.add('lx-lock');
    $$('[data-lx-mm-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var c = $('[data-lx-mm-close].lx-ic', mm.el); if (c) c.focus(); }, 60);
  }
  function mmClose() {
    if (!mm.el || !mm.el.classList.contains('is-open')) return;
    mm.el.classList.remove('is-open');
    document.documentElement.classList.remove('lx-lock');
    $$('[data-lx-mm-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var el = mm.el; setTimeout(function () { el.hidden = true; }, 280);
    if (mm.opener) mm.opener.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lx-mm-open]'); if (o) { e.preventDefault(); mmOpen(o); return; }
    if (e.target.closest('[data-lx-mm-close]')) { e.preventDefault(); mmClose(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!mm.el || !mm.el.classList.contains('is-open')) return;
    if (e.key === 'Escape') mmClose(); else trap($('.lx-mm__panel', mm.el), e);
  });

  var sr = { el: null, opener: null, seq: 0, timer: null };
  function srOpen(btn) {
    sr.el = document.getElementById('lx-search');
    if (!sr.el) { window.location.href = R.search_url || '/search'; return; }
    sr.opener = btn; sr.el.hidden = false;
    document.documentElement.classList.add('lx-lock');
    /* focus inside the tap itself: iPhone Safari only opens the keyboard for a focus() made during the user's tap, never from a timer */
    var i = $('input[type=search]', sr.el);
    if (i) { i.focus(); runSearch(i); }
  }
  function srClose() {
    if (!sr.el || sr.el.hidden) return;
    sr.el.hidden = true; document.documentElement.classList.remove('lx-lock');
    if (sr.opener) sr.opener.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lx-search-open]'); if (o) { e.preventDefault(); srOpen(o); return; }
    if (e.target.closest('[data-lx-search-close]') || (sr.el && e.target === sr.el)) { e.preventDefault(); srClose(); }
  });
  document.addEventListener('keydown', function (e) { if (sr.el && !sr.el.hidden) { if (e.key === 'Escape') srClose(); else trap($('.lx-search__box', sr.el), e); } });
  /* ---------- search: typo tolerant, Arabic aware, suggestions ---------- */
  var AR = /^ar/.test(document.documentElement.lang || '');
  var SX = {
    pop: AR ? 'عمليات بحث شائعة' : 'Popular searches',
    cats: AR ? 'الأقسام' : 'Categories',
    prods: AR ? 'المنتجات' : 'Products',
    sugg: AR ? 'اقتراحات' : 'Suggestions',
    mean: AR ? 'هل تقصد' : 'Did you mean',
    none: AR ? 'لا توجد نتائج لـ [q]. جرّبي كلمة أخرى.' : 'No results for [q]. Try another word.',
    all: AR ? 'عرض كل النتائج' : 'See all results',
    reco: AR ? 'منتجات مقترحة' : 'Recommended'
  };
  var POP = AR ? ['كولاجين', 'جلوتاثيون', 'البشرة', 'الشعر', 'الأظافر', 'نباتي'] : ['Collagen', 'Glutathione', 'Skin', 'Hair', 'Nails', 'Vegan'];
  /* Arabic and common spellings mapped to the English words in the catalog */
  var SYN = {
    'شامبو': 'shampoo', 'شامبوو': 'shampoo', 'شمبو': 'shampoo', 'ارز': 'rice', 'رز': 'rice', 'الارز': 'rice', 'الرز': 'rice',
    'تساقط': 'fall', 'تساقط الشعر': 'hair fall', 'شعر': 'hair', 'الشعر': 'hair', 'ماسك': 'mask', 'قناع': 'mask', 'سيروم': 'serum',
    'زيت': 'oil', 'زيوت': 'oils', 'كيراتين': 'keratin', 'مزيل': 'deodorant', 'عرق': 'deodorant', 'مزيل عرق': 'deodorant',
    'وجه': 'face', 'الوجه': 'face', 'كريم': 'cream', 'صابون': 'soap', 'مكياج': 'make up', 'ميكب': 'make up', 'روج': 'lip',
    'احمر شفاه': 'lipstick', 'ماسكرا': 'mascara', 'عطر': 'mist', 'بودرة': 'powder', 'زبدة': 'butter', 'مجموعة': 'set', 'باقة': 'bundle',
    'عروض': 'bundle', 'الوفيرا': 'aloe', 'صبار': 'aloe', 'ياسمين': 'jasmine', 'ورد': 'rose', 'بصل': 'onion', 'ارقطيون': 'burdock',
    'shampoos': 'shampoo', 'shampo': 'shampoo', 'shamp': 'shampoo', 'champoo': 'shampoo', 'rise': 'rice', 'deo': 'deodorant',
    'deodorants': 'deodorant', 'makeup': 'make up', 'masks': 'mask', 'serums': 'serum', 'hairfall': 'hair fall', 'kertain': 'keratin',
    'keratine': 'keratin', 'lipstik': 'lipstick', 'bundles': 'bundle', 'offers': 'bundle', 'sets': 'set'
  };
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ْـ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 1632); })
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/&amp;/g, '&').replace(/[|,.()+\-_/:!?'"’]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  /* Arabic store: other spellings of the same Arabic word, and the Arabic word for each English catalog word */
  var ASYN = { 'رز': 'ارز', 'الرز': 'ارز', 'قناع': 'ماسك', 'شامبوو': 'شامبو', 'شمبو': 'شامبو', 'ميكب': 'مكياج', 'صبار': 'الوفيرا' };
  var REV = {};
  Object.keys(SYN).forEach(function (k) { if (/[\u0600-\u06FF]/.test(k) && k.indexOf(' ') < 0 && !REV[SYN[k]]) REV[SYN[k]] = norm(k); });
  /* an Arabic word also counts without its joined prefix: الارز, بالارز and وبالارز all match ارز */
  function withStems(words) {
    var out = words.slice();
    words.forEach(function (w) {
      if (!/[\u0600-\u06FF]/.test(w)) return;
      var st = w.replace(/^(وبال|وال|بال|كال|فال|لل|ال)/, '');
      if (st === w && w.length >= 5) st = w.replace(/^[وبل]/, '');
      if (st !== w && st.length >= 2) out.push(st);
    });
    return out;
  }
  function expand(q) {
    var n = norm(q);
    Object.keys(SYN).forEach(function (k) { var nk = norm(k); if (nk.indexOf(' ') > -1 && n.indexOf(nk) > -1) n = n.replace(nk, SYN[k]); });
    return n.split(' ').map(function (w) { return SYN[w] ? norm(SYN[w]) : w; }).join(' ').split(' ').filter(Boolean);
  }
  /* edit distance where two swapped letters count as one edit (the swap needs the row two back) */
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var pp = null, p = [], c, i, j;
    for (j = 0; j <= b.length; j++) p[j] = j;
    for (i = 1; i <= a.length; i++) {
      c = [i]; var lo = i;
      for (j = 1; j <= b.length; j++) {
        c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (pp && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) c[j] = Math.min(c[j], pp[j - 2] + 1);
        if (c[j] < lo) lo = c[j];
      }
      if (lo > max) return max + 1;
      pp = p; p = c;
    }
    return p[b.length];
  }
  function tokScore(q, w) {
    if (w === q) return 3;
    if (w.indexOf(q) === 0) return q.length >= 2 ? 2.5 : 0;
    if (q.length === 4 && w.length >= 4) {
      /* 4 letter words: only two swapped letters count as a typo (hiar is hair); a changed letter is another word (rice is not rich) */
      var w4 = w.slice(0, 4);
      if (w4 !== q && w4.split('').sort().join('') === q.split('').sort().join('') && lev(q, w4, 1) <= 1) return 1.6;
    } else if (q.length >= 5 && w.length >= 4) {
      var max = q.length >= 7 ? 2 : 1, d = lev(q, w.slice(0, Math.max(q.length, Math.min(w.length, q.length + 1))), max);
      if (d <= max) return 2 - d * 0.4;
      d = lev(q, w, max); if (d <= max) return 1.9 - d * 0.4;
    }
    if (q.length >= 3 && w.indexOf(q) > 0) return 1.2;
    return 0;
  }
  var IDX = { p: null, c: null, vocab: null, loading: null };
  function cleanTitle(s) { return String(s || '').split(' | ')[0].replace(/^ANG-\s*/i, 'ANG ').replace(/\s+[-\u2013\u2014]\s+/g, ', ').replace(/\s*[\u2013\u2014]\s*/g, ', '); }
  function loadIndex() {
    if (IDX.loading) return IDX.loading;
    var key = 'lxSearchIdx2:' + (R.root || '/'), cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && cached.t > Date.now() - 36e5) { build(cached.p, cached.c); IDX.loading = Promise.resolve(); return IDX.loading; }
    var root = (R.root || '/').replace(/\/?$/, '/');
    IDX.loading = Promise.all([
      fetch(root + 'products.json?limit=250').then(function (r) { return r.json(); }),
      fetch(root + 'collections.json?limit=100').then(function (r) { return r.json(); })
    ]).then(function (a) {
      var ps = (a[0].products || []).map(function (p) {
        var v = p.variants && p.variants[0] || {};
        return { h: p.handle, t: p.title, ty: p.product_type, tg: p.tags, img: p.images && p.images[0] ? p.images[0].src : '', pr: v.price, cp: v.compare_at_price, av: (p.variants || []).some(function (x) { return x.available; }) };
      });
      var cs = (a[1].collections || []).filter(function (c) { return c.products_count > 0 && !/^(all|frontpage|home)/.test(c.handle); }).map(function (c) { return { h: c.handle, t: c.title, n: c.products_count }; });
      try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: ps, c: cs })); } catch (e) {}
      build(ps, cs);
    }).catch(function () { IDX.loading = null; });
    return IDX.loading;
  }
  function build(ps, cs) {
    var vocab = {};
    IDX.p = ps.map(function (p) {
      var main = norm(cleanTitle(p.t)), all = norm(p.t + ' ' + (p.ty || '') + ' ' + (Array.isArray(p.tg) ? p.tg.join(' ') : p.tg || ''));
      main.split(' ').concat(norm(p.ty || '').split(' ')).forEach(function (w) { if (w.length > 2 && !/^\d+$/.test(w)) vocab[w] = (vocab[w] || 0) + 1; });
      return { d: p, main: withStems(main.split(' ')), all: withStems(all.split(' ')) };
    });
    IDX.c = cs.map(function (c) { var n = norm(c.t); n.split(' ').forEach(function (w) { if (w.length > 2) vocab[w] = (vocab[w] || 0) + 2; }); return { d: c, w: withStems(n.split(' ')) }; });
    IDX.vocab = Object.keys(vocab).map(function (w) { return [w, vocab[w]]; });
    IDX.ar = ps.some(function (p) { return /[\u0600-\u06FF]/.test(p.t || ''); });
  }
  function scoreWords(qt, mainW, allW) {
    var tot = 0, hit = 0;
    qt.forEach(function (q) {
      var best = 0;
      mainW.forEach(function (w) { var s = tokScore(q, w) * 1.25; if (s > best) best = s; });
      allW.forEach(function (w) { var s = tokScore(q, w); if (s > best) best = s; });
      if (best > 0) hit++; tot += best;
    });
    return hit === qt.length ? tot : (qt.length > 2 && hit >= qt.length - 1 ? tot * 0.5 : 0);
  }
  /* words as typed (an Arabic catalog matches them) and mapped to the English catalog words; the better match wins */
  function qLists(q) {
    var qe = expand(q), qa = norm(q).split(' ').filter(Boolean).map(function (w) { return ASYN[w] ? norm(ASYN[w]) : w; });
    var lists = [qe], seen = {}; seen[qe.join(' ')] = 1;
    [qa, qe.map(function (w) { return REV[w] || w; })].forEach(function (l) { var k = l.join(' '); if (l.length && !seen[k]) { seen[k] = 1; lists.push(l); } });
    return lists;
  }
  function best(lists, main, all) {
    var r = { s: 0, n: 1 };
    lists.forEach(function (qt) { var s = scoreWords(qt, main, all); if (s > r.s) r = { s: s, n: qt.length }; });
    return r;
  }
  function searchIdx(q) {
    var lists = qLists(q), qt = lists[0]; if (!qt.length || !IDX.p) return { p: [], c: [], s: [], fix: '' };
    /* suggestions come from the catalog words, so use the list in the catalog's language */
    if (IDX.ar && lists[1] && /[\u0600-\u06FF]/.test(q)) qt = lists[1];
    var ps = IDX.p.map(function (x) { var b = best(lists, x.main, x.all); return { x: x, s: b.s + (x.d.av ? 0.3 : 0), n: b.n }; })
      .filter(function (r) { return r.s > 0.3 * r.n + 0.3; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 6).map(function (r) { return r.x.d; });
    var cs = IDX.c.map(function (x) { return { x: x, s: best(lists, x.w, x.w).s }; })
      .filter(function (r) { return r.s > 0; }).sort(function (a, b) { return b.s - a.s || b.x.d.n - a.x.d.n; }).slice(0, 4).map(function (r) { return r.x.d; });
    /* word suggestions: complete or correct the last word */
    /* earlier words are corrected to the closest catalog word (hiar mask suggests hair mask) */
    var vset = {}; IDX.vocab.forEach(function (v) { vset[v[0]] = 1; });
    var fixWord = function (w) { if (vset[w]) return w; var b = '', bs = 1.5; IDX.vocab.forEach(function (v) { var sc = tokScore(w, v[0]); if (sc > bs) { bs = sc; b = v[0]; } }); return b || w; };
    var last = qt[qt.length - 1], head = qt.slice(0, -1).map(fixWord).join(' '), seen = {}, sug = [];
    var exact = !!vset[last];
    var whole = (head ? head + ' ' : '') + (exact ? last : fixWord(last));
    if (whole !== norm(q) && (exact || whole !== (head ? head + ' ' : '') + last)) { seen[whole] = 1; sug.push(whole); }
    IDX.vocab.map(function (v) { var s = tokScore(last, v[0]); return [v[0], s ? s + Math.min(v[1], 10) / 20 : 0]; })
      .filter(function (v) { return v[1] > (exact ? 2.4 : 0) && v[0] !== last; }).sort(function (a, b) { return b[1] - a[1]; })
      .forEach(function (v) { var t = (head ? head + ' ' : '') + v[0]; var sg = t.replace(/s$/, ''); if (!seen[t] && !seen[sg] && !seen[t + 's'] && sug.length < 4) { seen[t] = 1; seen[sg] = 1; sug.push(t); } });
    var fix = '';
    if (!ps.length || ps.length && qt.some(function (w) { return !IDX.vocab.some(function (v) { return v[0] === w || v[0].indexOf(w) === 0 || (IDX.ar && v[0].indexOf(w) > 0); }); })) fix = sug[0] || '';
    return { p: ps, c: cs, s: sug, fix: fix };
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function mark(title, q) {
    var t = esc(title), qt = expand(q).concat(norm(q).split(' ')).filter(function (w) { return w.length > 1; });
    qt.forEach(function (w) { t = t.replace(new RegExp('(^|[^\\w])(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '[\\w]*)', 'i'), '$1<mark>$2</mark>'); });
    return t;
  }
  function pageQ(q) { return IDX.p && !IDX.ar && /[\u0600-\u06FF]/.test(q) ? expand(q).join(' ') : q; }
  function searchUrl(q) { return (R.search_url || '/search') + '?type=product&q=' + encodeURIComponent(pageQ(q)); }
  function root() { return (R.root || '/').replace(/\/?$/, '/'); }
  function chips(list, cls) { return '<div class="lx-search__chips">' + list.map(function (s) { return '<button type="button" class="lx-chip' + (cls || '') + '" data-lx-sq="' + esc(s) + '">' + esc(s) + '</button>'; }).join('') + '</div>'; }
  function renderEmpty(out) {
    var html = '<p class="lx-search__h">' + SX.pop + '</p>' + chips(POP);
    if (IDX.c && IDX.c.length) html += '<p class="lx-search__h">' + SX.cats + '</p><div class="lx-search__chips">' + IDX.c.slice().sort(function (a, b) { return b.d.n - a.d.n; }).slice(0, 8).map(function (c) { return '<a class="lx-chip lx-chip--ghost" href="' + root() + 'collections/' + c.d.h + '">' + esc(c.d.t) + '</a>'; }).join('') + '</div>';
    out.innerHTML = html;
  }
  function row(p, q) {
    var img = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
    var pr = p.pr ? money(Math.round(parseFloat(p.pr) * 100)) : '', cp = p.cp && parseFloat(p.cp) > parseFloat(p.pr) ? money(Math.round(parseFloat(p.cp) * 100)) : '';
    return '<a class="lx-search__p" href="' + root() + 'products/' + p.h + '">' + (img ? '<img src="' + img + '" alt="" width="56" height="56" decoding="async">' : '') +
      '<span>' + (q ? mark(cleanTitle(p.t), q) : esc(cleanTitle(p.t))) + '</span><b>' + pr + (cp ? '<s>' + cp + '</s>' : '') + '</b></a>';
  }
  /* best sellers picked in theme settings (Search), shown under No results; falls back to tagged best sellers */
  function reco() {
    if (!IDX.p) return [];
    var by = {}; IDX.p.forEach(function (x) { by[x.d.h] = x.d; });
    var list = (window.lxReco || []).map(function (h) { return by[h]; }).filter(function (d) { return d && d.av; });
    if (!list.length) list = IDX.p.map(function (x) { return x.d; }).filter(function (d) { return d.av && /best.?seller/i.test(Array.isArray(d.tg) ? d.tg.join(' ') : d.tg || ''); });
    return list.slice(0, 4);
  }
  /* Shopify returns related products even for words no product contains; keep one only when every word is in its text */
  function hasWords(p, q) {
    var qt = expand(q);
    if (qt.some(function (w) { return /[\u0600-\u06FF]/.test(w); })) return true;
    var txt = ' ' + norm([p.title, p.body ? String(p.body).replace(/<[^>]+>/g, ' ') : '', Array.isArray(p.tags) ? p.tags.join(' ') : p.tags || '', p.type || '', p.vendor || ''].join(' ')) + ' ';
    return qt.every(function (w) { return txt.indexOf(' ' + w) > -1; });
  }
  function renderQ(out, q, extra) {
    var r = searchIdx(q), html = '';
    var ids = {}; r.p.forEach(function (p) { ids[p.h] = 1; });
    (extra || []).forEach(function (p) { if (!ids[p.h] && r.p.length < 6) { ids[p.h] = 1; r.p.push(p); } });
    if (r.fix && norm(r.fix) !== norm(q)) html += '<p class="lx-search__fix">' + SX.mean + ' <button type="button" class="lx-link" data-lx-sq="' + esc(r.fix) + '">' + esc(r.fix) + '</button>?</p>';
    if (r.s.length) html += '<p class="lx-search__h">' + SX.sugg + '</p><ul class="lx-search__sugg">' + r.s.map(function (s) { return '<li><button type="button" data-lx-sq="' + esc(s) + '">' + render_icon_search + '<span>' + mark(s, q) + '</span></button></li>'; }).join('') + '</ul>';
    if (r.c.length) html += '<p class="lx-search__h">' + SX.cats + '</p><div class="lx-search__chips">' + r.c.map(function (c) { return '<a class="lx-chip lx-chip--ghost" href="' + root() + 'collections/' + c.h + '">' + esc(c.t) + ' <small>' + c.n + '</small></a>'; }).join('') + '</div>';
    if (r.p.length) {
      html += '<p class="lx-search__h">' + SX.prods + '</p>' + r.p.map(function (p) { return row(p, q); }).join('');
      html += '<p class="lx-search__q"><a class="lx-link" href="' + searchUrl(q) + '">' + SX.all + '</a></p>';
    }
    if (!r.p.length && !r.c.length) {
      html += '<p class="lx-search__none" role="status">' + SX.none.replace('[q]', '&ldquo;' + esc(q) + '&rdquo;') + '</p><p class="lx-search__h">' + SX.pop + '</p>' + chips(POP);
      var rc = reco();
      if (rc.length) html += '<p class="lx-search__h">' + SX.reco + '</p>' + rc.map(function (p) { return row(p); }).join('');
    }
    out.innerHTML = html;
  }
  var render_icon_search = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4-4"/></svg>';
  function runSearch(inp) {
    var out = $('[data-lx-search-res]', sr.el || document); if (!out) return;
    var q = inp.value.trim();
    clearTimeout(sr.timer);
    loadIndex();
    if (q.length < 2) { (IDX.loading || Promise.resolve()).then(function () { if (inp.value.trim().length < 2) renderEmpty(out); }); return; }
    sr.timer = setTimeout(function () {
      var mine = ++sr.seq;
      (IDX.loading || Promise.resolve()).then(function () {
        if (mine !== sr.seq) return;
        renderQ(out, q);
        /* Shopify's own matching adds products our index ranked out; it does not support Arabic (answers 417) */
        if (AR) return;
        fetch(root() + 'search/suggest.json?q=' + encodeURIComponent(expand(q).join(' ')) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (d) {
            if (mine !== sr.seq) return;
            var ps = ((d.resources && d.resources.results && d.resources.results.products) || []).filter(function (p) { return hasWords(p, q); }).map(function (p) {
              return { h: p.handle, t: p.title, img: p.featured_image && p.featured_image.url || p.image || '', pr: p.price, cp: p.compare_at_price_max };
            });
            if (ps.length) renderQ(out, q, ps);
          }).catch(function () {});
      });
    }, 160);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('#lx-search form'); if (!f) return;
    var inp = $('input[type=search]', f); if (inp) inp.value = pageQ(inp.value.trim());
  });
  document.addEventListener('input', function (e) { var inp = e.target.closest('#lx-search input[type=search]'); if (inp) runSearch(inp); });
  document.addEventListener('focusin', function (e) { var inp = e.target.closest('#lx-search input[type=search]'); if (inp) runSearch(inp); });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-sq]'); if (!b) return;
    var inp = $('#lx-search input[type=search]'); if (!inp) return;
    e.preventDefault(); inp.value = b.getAttribute('data-lx-sq'); inp.focus(); runSearch(inp);
  });
  document.addEventListener('keydown', function (e) {
    if (!sr.el || sr.el.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
    var items = $$('[data-lx-search-res] a, [data-lx-search-res] button', sr.el); if (!items.length) return;
    var i = items.indexOf(document.activeElement);
    e.preventDefault();
    if (e.key === 'ArrowDown') (items[i + 1] || items[0]).focus();
    else if (i <= 0) $('input[type=search]', sr.el).focus(); else items[i - 1].focus();
  });

  /* ---------------- product page (scoped per section) ---------------- */
  ready(function () {
    $$('[data-lx-pdp]').forEach(function (sec) {
      var form = $('form[data-lx-pform]', sec);
      /* gallery */
      var track = $('.lx-gal__track', sec);
      var slides = track ? $$('.lx-gal__slide', track) : [];
      var thumbs = $$('.lx-gal__thumb', sec);
      var dots = $$('.lx-gal__dots button', sec);
      function cur() { if (!track || !slides.length) return 0; var w = slides[0].getBoundingClientRect().width || 1; return Math.round(Math.abs(track.scrollLeft) / (w + (parseFloat(getComputedStyle(track).columnGap) || 0))); }
      function go(i) {
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        var s = slides[i];
        track.scrollTo({ left: s.offsetLeft - track.offsetLeft - (parseFloat(getComputedStyle(track).paddingInlineStart) || 0), behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      }
      function mark(i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', i === j); t.setAttribute('aria-current', i === j ? 'true' : 'false'); });
        dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
        slides.forEach(function (sl, j) { if (j !== i) { var v = $('video', sl); if (v && !v.paused) v.pause(); } });
      }
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      var pv = $('.lx-gal__prev', sec), nx = $('.lx-gal__next', sec);
      var rtl = document.documentElement.dir === 'rtl';
      if (pv) pv.addEventListener('click', function () { go(cur() + (rtl ? 1 : -1)); });
      if (nx) nx.addEventListener('click', function () { go(cur() + (rtl ? -1 : 1)); });
      if (track) track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(function () { mark(cur()); }, 60); }, { passive: true });

      /* description more */
      $$('[data-lx-more-desc]', sec).forEach(function (b) {
        b.addEventListener('click', function () { var d = b.closest('.lx-desc'); var o = d.classList.toggle('is-open'); b.textContent = o ? (S.less || 'Show less') : (S.more || 'Read more'); b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      });

      if (!form) return;
      var idEl = $('[data-lx-vid]', form);
      var qtyEl = $('[data-lx-qty]', form);
      var btn = $('[type=submit][name=add]', form);
      function btnState(avail, cents) {
        if (!btn) return;
        btn.disabled = !avail;
        var l = $('[data-lx-btnl]', btn), p = $('[data-lx-btnp]', btn);
        if (l) l.textContent = avail ? (S.add || 'Add to bag') : (S.soldOut || 'Sold out');
        if (p) { p.hidden = !avail; if (cents != null) p.textContent = money(cents); }
      }
      var priceBox = $('[data-lx-price]', sec);
      var stickyPrice = $$('[data-lx-sticky-price]', sec.parentNode || document);
      var variants = []; try { variants = JSON.parse(($('[data-lx-variants]', sec) || {}).textContent || '[]'); } catch (e) {}
      var groups = $$('[data-lx-opt]', sec);
      var tierWrap = $('[data-lx-tiers]', sec);
      var userChanged = false;
      var current = variants.filter(function (v) { return String(v.id) === (idEl && idEl.value); })[0] || variants[0];

      function setPrice(v, unitOverride, cmpOverride) {
        if (!priceBox || !v) return;
        var p = unitOverride != null ? unitOverride : v.price;
        var c = cmpOverride != null ? cmpOverride : v.compare_at_price;
        var pe = $('[data-lx-p]', priceBox), ce = $('[data-lx-c]', priceBox), se = $('[data-lx-s]', priceBox);
        if (pe) pe.textContent = money(p);
        var sale = c && c > p;
        if (ce) { ce.textContent = sale ? money(c) : ''; ce.hidden = !sale; }
        if (se) { se.textContent = sale ? (S.save || 'Save [p]%').replace('[p]', Math.round((c - p) * 100 / c)) : ''; se.hidden = !sale; }
        stickyPrice.forEach(function (el) { el.textContent = money(p); });
        $$('[data-lx-tabby]', sec).forEach(function (el) { el.textContent = (el.getAttribute('data-tpl') || '').replace('[amount]', money(Math.round(p / 4))); });
      }
      function fits(v, vals) { return vals.every(function (val, i) { return val == null || v.options[i] === val; }); }
      function chosen() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
      function marks(vals) {
        groups.forEach(function (g, gi) {
          $$('input', g).forEach(function (inp) {
            var test = vals.slice(); test[gi] = inp.value;
            var ok = variants.some(function (v) { return v.available && fits(v, test); });
            var lab = $('label[for="' + inp.id + '"]', g); if (lab) lab.classList.toggle('is-na', !ok);
          });
          var lv = $('[data-lx-optv]', g); if (lv && vals[gi]) lv.textContent = vals[gi];
        });
      }
      function resolve() {
        if (!groups.length) { applyTier(); return; }
        var vals = chosen();
        marks(vals);
        var m = variants.filter(function (v) { return fits(v, vals) && vals.every(function (x) { return x != null; }); })[0];
        if (!m) {
          if (idEl) idEl.value = '';
          if (btn) { btnState(false); var l0 = $('[data-lx-btnl]', btn); if (l0) l0.textContent = S.unavailable || 'Unavailable'; }
          $$('[data-lx-sticky-btn]').forEach(function (b) { b.disabled = true; });
          return;
        }
        current = m;
        if (idEl) idEl.value = m.id;
        if (userChanged && variants.length > 1 && window.history && history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', m.id); history.replaceState({}, '', u.toString()); } catch (e) {}
        }
        btnState(m.available, m.price);
        $$('[data-lx-sticky-btn]').forEach(function (b) { b.disabled = !m.available; });
        if (userChanged && m.featured_media) {
          var idx = slides.map(function (s) { return s.getAttribute('data-media'); }).indexOf(String(m.featured_media.id));
          if (idx > -1) go(idx);
        }
        applyTier();
      }
      /* native bundle tiers: the tier sets the quantity; the shown price is the tier price the
         merchant entered, which MUST match a live Shopify discount (theme editor says so) */
      function applyTier() {
        if (!tierWrap) { setPrice(current); return; }
        var on = $('input:checked', tierWrap);
        $$('.lx-tier', tierWrap).forEach(function (t) { t.classList.toggle('is-on', !!$('input:checked', t)); });
        if (!on) { setPrice(current); if (current) btnState(current.available, current.price); return; }
        var q = parseInt(on.getAttribute('data-q'), 10) || 1;
        var tp = parseInt(on.getAttribute('data-tp'), 10);
        /* Lovu: a subscription plan rides on the same radio group */
        var plan = on.getAttribute('data-plan'), spEl = form && form.querySelector('input[name="selling_plan"]');
        if (form) { if (plan) { if (!spEl) { spEl = document.createElement('input'); spEl.type = 'hidden'; spEl.name = 'selling_plan'; form.appendChild(spEl); } spEl.value = plan; } else if (spEl) { spEl.remove(); } }
        sec.classList.toggle('lx-is-sub', !!plan);
        if (qtyEl) qtyEl.value = q;
        var unit = current ? current.price : 0;
        var total = tp > 0 ? tp : unit * q;
        var cmpUnit = current && current.compare_at_price > unit ? current.compare_at_price : unit;
        setPrice(current, total, cmpUnit * q);
        /* Lovu 19/10: per-day line follows the pack, 30 days per jar */
        $$('[data-lx-perday]', sec).forEach(function (el) { var jars = parseInt(el.getAttribute('data-jars'), 10) || 1; el.textContent = (el.getAttribute('data-tpl') || '').replace('[amount]', moneyFull(Math.round(total / (q * jars * 30)))); });
        if (current) btnState(current.available, total);
        $$('[data-lx-sticky-name]', sec).forEach(function (el) { el.textContent = on.getAttribute('data-n') || ''; });
      }
      groups.forEach(function (g) { g.addEventListener('change', function () { userChanged = true; resolve(); }); });
      if (tierWrap) tierWrap.addEventListener('change', function () { applyTier(); });
      /* quantity stepper */
      $$('[data-lx-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyEl) return;
          qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) + parseInt(b.getAttribute('data-lx-step'), 10));
          if (tierWrap) { var on = $('input:checked', tierWrap); if (on) { on.checked = false; applyTier(); } }
        });
      });
      resolve();

      /* sticky bar */
      var bar = document.getElementById('lx-sticky-' + sec.getAttribute('data-section'));
      if (bar && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-on', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          $$('a,button', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
          document.body.classList.toggle('lx-sticky-on', show);
        });
        io.observe(btn);
        $$('[data-lx-sticky-btn]', bar).forEach(function (sb) {
          sb.addEventListener('click', function () {
            if (btn.disabled) return;
            if (window.lxAddForm && !form.hasAttribute('data-no-ajax')) window.lxAddForm(form); else btn.click();
          });
        });
      }
    });
  });

  /* ---------------- before / after ---------------- */
  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-lx-ba]'); if (!r) return;
    var v = r.closest('.lx-ba__view'); if (v) v.style.setProperty('--pos', r.value + '%');
  });

  /* ---------------- videos: one plays at a time, pause when out of view ---------------- */
  ready(function () {
    var vids = $$('[data-lx-video]');
    if (!vids.length) return;
    function stopOthers(keep) { vids.forEach(function (w) { var v = $('video', w); if (w !== keep && v && !v.paused) { v.pause(); w.classList.remove('is-playing'); } }); }
    vids.forEach(function (w) {
      var v = $('video', w), play = $('.lx-vid__play', w), mute = $('.lx-vid__btn', w);
      if (!v) return;
      function toggle() { if (v.paused) { stopOthers(w); v.play().then(function () { w.classList.add('is-playing'); }).catch(function () {}); } else { v.pause(); w.classList.remove('is-playing'); } }
      if (play) play.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      if (mute) mute.addEventListener('click', function () { v.muted = !v.muted; mute.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); mute.setAttribute('aria-label', v.muted ? (S.unmute || 'Turn sound on') : (S.mute || 'Turn sound off')); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (!x.isIntersecting) { var v = $('video', x.target); if (v && !v.paused) { v.pause(); x.target.classList.remove('is-playing'); } } }); }, { threshold: .15 });
      vids.forEach(function (w) { io.observe(w); });
    }
  });

  /* ---------------- rails: arrow buttons scroll their own rail ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-rail]'); if (!b) return;
    var rail = document.getElementById(b.getAttribute('aria-controls')); if (!rail) return;
    var dir = parseInt(b.getAttribute('data-lx-rail'), 10) * (document.documentElement.dir === 'rtl' ? -1 : 1);
    rail.scrollBy({ left: dir * rail.clientWidth * .85, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------------- collection: filters drawer, auto submit, load more ---------------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lx-filters-open]');
    if (o) { var f = document.getElementById('lx-filters'); if (f) { f.classList.add('is-open'); document.documentElement.classList.add('lx-lock'); var c = $('[data-lx-filters-close]', f); if (c) c.focus(); } return; }
    if (e.target.closest('[data-lx-filters-close]') || e.target.id === 'lx-filters') {
      var f2 = document.getElementById('lx-filters'); if (f2) { f2.classList.remove('is-open'); document.documentElement.classList.remove('lx-lock'); }
    }
  });
  document.addEventListener('change', function (e) {
    var f = e.target.closest('form[data-lx-autosubmit]');
    if (f && window.matchMedia('(min-width: 990px)').matches) f.submit();
    if (e.target.matches('[data-lx-sort]')) e.target.form.submit();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-loadmore]'); if (!b) return;
    e.preventDefault();
    var url = b.getAttribute('href'); if (!url) return;
    b.classList.add('is-busy');
    fetch(url).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.querySelector('[data-lx-grid]'), ng = doc.querySelector('[data-lx-grid]');
      if (grid && ng) $$('[data-lx-item]', ng).forEach(function (it) { grid.appendChild(it); });
      var more = document.querySelector('[data-lx-more]'), nm = doc.querySelector('[data-lx-more]');
      if (more && nm) more.innerHTML = nm.innerHTML; else if (more) more.remove();
      try { history.replaceState({}, '', url); } catch (x) {}
    }).catch(function () { window.location.href = url; });
  });

  /* ---------------- product recommendations ---------------- */
  ready(function () {
    $$('[data-lx-recs]').forEach(function (box) {
      if (box.children.length) return;
      fetch(box.getAttribute('data-url')).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-lx-recs]');
        if (fresh && fresh.children.length) box.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  });

  ready(function () { cart.badge(); });
})();
